import { useAppComponentTooltips } from "@1js/acui-tooltip";
import { useAppButtonState } from "../../AppButton/next";
import type {
  AppToggleButtonProps,
  AppToggleButtonState,
} from "../../AppToggleButton/next";

import { useToggleButton_unstable } from "@fluentui/react-components";

export const useAppSplitButtonPrimaryToggleButton = (
  props: AppToggleButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppToggleButtonState => {
  const { disabled, toggled, customTooltip, tooltipDirection } = props;

  // Remove ID so it doesn't get added as an attribute on the HTML button
  const { id, ...propsWithoutId } = props;

  const { mergedRef } = useAppComponentTooltips(ref, {
    ...props,
    direction: tooltipDirection,
  });

  // if customTooltip is passed in as a prop, attach a tooltip to the ref, otherwise use the default ref
  const primaryButtonRef = customTooltip ? mergedRef : ref;

  // 'type' override here needed so that our types (e.g. "AppToggleButtonProps") aren't assigned to the HTML element
  const state = useToggleButton_unstable(
    {
      ...propsWithoutId,
      checked: toggled,
      type: "button",
      disabledFocusable: disabled,
    },
    primaryButtonRef
  );

  useAppButtonState(props, state);

  return state;
};
